import React, { useEffect, useState } from 'react';
import { naac, grade, nba, yellowBox, Best_Image } from '../../assets/index';
import { getRecognitionsAndApprovals } from '../../services/getAllApi';

const ApprovalCard = ({ image, title, subtitle, isBottomRow }) => {
  return (
    <div className="border border-gray-300 flex flex-col items-center p-4 transform transition-all duration-300 hover:shadow-xl hover:scale-105 hover:border-[#EC8305]">
      <img 
        src={image} 
        className="h-[10rem] lg:h-[13rem] w-auto object-contain transition-transform duration-300 hover:scale-110" 
      />
      <div className="bg-[#000080] w-full h-auto mt-4 flex items-center justify-center p-2 transition-colors duration-300 hover:bg-[#000065]">
        <p className="text-white text-center text-sm lg:text-lg font-semibold">
          {title}
        </p>
      </div>
      {isBottomRow && (
        <div className="w-full mt-4 flex items-center justify-center transform transition-all duration-300 hover:text-[#EC8305]">
          <p className="text-center font-bold px-2">{subtitle}</p>
        </div>
      )}
    </div>
  );
};

const Approvals = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    // Define the async function inside useEffect
    const fetchData = async () => {
      try {
        const response = await getRecognitionsAndApprovals();
      
        setItems(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.log(error);
      }
    };

    // Call the async function
    fetchData();
  }, []); // Empty dependency array ensures this runs once on mount

  return (
    <div className="w-full bg-white text-justify p-8">
      <div className="px-4">
        <div>
          <h1 className="text-3xl font-bold mb-4 text-[#EC8305] lg:static sm:right-[9.5rem] animate-fadeIn">
            Recognition and Approvals
          </h1>
          <div className="w-full lg:w-[30rem] h-[0.09rem] bg-[#EC8305] relative lg:-right-[0rem] bottom-[1rem] animate-expand"></div>

          <div className="flex flex-col lg:flex-row gap-8">
            <div className="w-full lg:w-[40%] overflow-hidden">
              <img 
                src={yellowBox} 
                className="w-full h-[25rem] md:h-[30rem] object-cover transition-transform duration-500 hover:scale-105"
              />
            </div>
            <div className="w-full lg:w-[60%]">
              {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <ApprovalCard 
                  image={nba} 
                  title={<>Accredited by <span className="text-orange-300">NBA</span></>}
                />
                <ApprovalCard 
                  image={naac} 
                  title={<>Accredited by <span className="text-orange-300">NAAC</span></>}
                />
                <ApprovalCard 
                  image={grade} 
                  title={<>FBS'S <span className="text-orange-300">PDGM has been accorded equivalent with MBA degree</span></>}
                />
                <ApprovalCard 
                  image={nba} 
                  title={<>FBS'S <span className="text-orange-300">PDGM has been accorded equivalent with MBA degree</span></>}
                />
              </div> */}
              <img  src={Best_Image} alt="" style={{width:'66%', marginLeft:'3rem'}}/>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
               {items && items.length>0 ?
               
               items.map((item)=>{
                return <ApprovalCard image={`${process.env.REACT_APP_IMGURL}/${item.image}`} title={item.description} key={item.id}/>
               })
                 : 
               " "}
                <ApprovalCard 
                  image={nba} 
                  title={<>Accredited by <span className="text-orange-300">AICTE</span></>}
                />
                <ApprovalCard 
                  image={naac} 
                  title={<>Accredited by <span className="text-orange-300">NAAC</span></>}
                />
                <ApprovalCard 
                  image={grade} 
                  title={<>Accredited by <span className="text-orange-300">UGC</span></>}
                />
                {/* <ApprovalCard 
                  image={nba} 
                  title={<>FBS'S <span className="text-orange-300">PDGM has been accorded equivalent with MBA degree</span></>}
                /> */}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes expand {
          from { width: 0; }
          to { width: 100%; }
        }

        .animate-fadeIn {
          animation: fadeIn 1s ease-out;
        }

        .animate-expand {
          animation: expand 1.5s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Approvals;
